<template>
    <div class="conversation-view">
        <div class="convo-history-side">
            <div class="convo-history-list">
                <ChatMessage
                    v-for="(chatMsg, index) in chatLog"
                    v-bind:key="index"
                    v-bind:sender="chatMsg.sender"
                    v-bind:isError="chatMsg.isError"
                    v-bind:message="chatMsg.message" />
            </div>
            <div class="user-dictation-text" v-bind:class="{ 'transmitting-text': userTextTransmitting }">
                <input type="text" class="user-input-text" @keyup.enter="ask()" v-model="userText"><button @click="ask()">Send</button>
            </div>
        </div>
        <div class="user-input-side">
            <div class="vidbaby-stt-button" @click="toggleMicrophone" :class="{'active':userTextTransmitting}">
                <i class="fa fa-microphone fa-4"></i>
            </div>
        </div>
    </div>
</template>
<script>
    import ChatMessage from '@/components/ChatMessage.vue';

    export default {
        name: 'ConversationView',
        created: function() {
            var self = this;
            vidbaby.$(document).on('na-question.vidbaby', function(event, data) {
                if(data.isCallback) return;
                if(data.question === '<<start>>') return;
                self.chatLog.push({
                    sender: 'user',
                    message: data.question
                });
                self.userText = '';
                self.userTextTransmitting = false;
            });
            vidbaby.$(document).on('na-response.vidbaby', function(event, data) {
                if(data.answerText) {
                    self.chatLog.push({
                        sender: 'avatar',
                        message: $(`<span>${data.answerText}</span>`).text()
                    });
                }
            });

            /*vidbaby.$(document).on('nlp-no_response', function(event, data) {
                 self.chatLog.push({
                    sender: 'avatar',
                    isError: true,
                    message: data.answerText
                });
            });*/
            vidbaby.$(document).on('na-microphoneData.vidbaby', function(event, data) {
                self.userText = data.text;
                if(data.isFinal) {
                    self.ask();
                }
            });
            vidbaby.$(document).on('na-microphoneStarted.vidbaby', function () {
                self.userTextTransmitting = true;
            });

            vidbaby.$(document).on('na-microphoneStopped.vidbaby', function () {
                self.userTextTransmitting = false;
            });
        },
        watch: {
            chatLog: function(val, oldVal) {
                this.$nextTick(function() {
                    var histView = this.$el.querySelector('.convo-history-list');
                    histView.scrollTop = histView.scrollHeight;
                });
            }
        },
        data: function() {
            return {
                chatLog: [],
                userText: '',
                userTextTransmitting: false,
            }
        },
        components: {
            ChatMessage
        },
        methods: {
            ask() {
                if(!this.userText) return;
                vidbaby.$(document).trigger('na-ask.vidbaby', this.userText);
                this.userText = '';
            },
            toggleMicrophone() {
                vidbaby.$(document).trigger('na-microphoneToggle.vidbaby');
            }
        }
    }
</script>
<style lang="stylus">
    @keyframes pulse
        0%
            background-color: #b5d16d;
        50%
            background-color: #f66;
        100%
            background-color: #b5d16d;

    .conversation-view
        display: flex
        z-index 100000
        position: absolute
        bottom: 19px
        right: 50px
        width: 800px
        height: 100px
        background: rgba(118, 172, 218, 0.5)
        border-radius: 5em
        padding: 0 3em
        color: #fff
        box-sizing: border-box
        .convo-history-side
            flex: 1
            display: flex
            flex-direction: column
            margin: 0.5em 1em 0.5em 0
            .convo-history-list
                overflow-x: hidden
                overflow-y: auto
            .user-dictation-text
                flex: 1
                transition: opacity 1s
                opacity: 1
                text-align: left;
                &.transmitting-text
                    opacity: 0.75
                input
                    width: 80%
                    font-size: 14px
                    vertical-align: middle;
                button
                    margin-left: 5px;
                    vertical-align: middle;
                    height: 27px;
        .user-input-side
            position: relative
            .vidbaby-stt-input
                display: none
            .vidbaby-stt-button
                cursor: pointer;
                font-size: 100px
                color: #fff
                border-radius: 100%
                background-color: #b5d16d;
                padding: 8px;
                margin: -8px
                margin-left: 0
                height: 100px;
                width: 100px;
                &.active
                    background-color: #f66;
                    animation-name: pulse;
                    animation-duration: 2s;
                    animation-iteration-count: infinite;
</style>